export const PHARMACY = 'pharmacy'
export const BAKERY = 'bakery'
export const SUPERMARKET = 'supermarket'

export const MAP_LAYER_TOPO = 'topo'
export const MAP_LAYER_IGN = 'ign'
export const MAP_OUTDOOR = 'MAP_OUTDOOR'
export const MAP_LAYER_OUT = 'MAP_LAYER_OUT'

export const layerList =  {
    [MAP_LAYER_TOPO] : 'Topo',
    [MAP_LAYER_IGN] : 'IGN',
    [MAP_OUTDOOR] : 'MAP_OUTDOOR',
    [MAP_LAYER_OUT] : 'MAP_LAYER_OUT',
}